import eimg1 from '../images/mission-vission/1.jpg';
import eimg2 from '../images/mission-vission/2.jpg';
import eimg3 from '../images/mission-vission/3.jpg';
import eimg4 from '../images/mission-vission/4.jpg';
import eimg5 from '../images/mission-vission/5.jpg';
import eimg6 from '../images/mission-vission/6.jpg';

import esing1 from '../images/events-single/1.jpg'
import esing2 from '../images/events-single/2.jpg'
import esing3 from '../images/events-single/3.jpg'
import esing4 from '../images/events-single/1.jpg'
import esing5 from '../images/events-single/3.jpg'
import esing6 from '../images/events-single/2.jpg'





const event = [
    {
        id: '1',
        title: 'Food & water Charity.',
        subtitle: 'Help The Poor, You Will Feel Happy',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Custom-Fabrication',
        eimg: eimg1,
        eSimg: esing1,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '2',
        title: 'Become a volunteer',
        subtitle: 'Help The Poor, You Will Feel Happy',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Become-a-volunteer',
        eimg: eimg2,
        eSimg: esing2,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '3',
        title: 'Send gift for children',
        subtitle: 'Help The Poor, You Will Feel Happy',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Send-gift-for-children',
        eimg: eimg3,
        eSimg: esing3,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '4',
        title: 'Help-for-Children',
        subtitle: 'Help The Poor, You Will Feel Happy',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Send-gift-for-children',
        eimg: eimg4,
        eSimg: esing4,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '5',
        title: 'Event Raised Poor',
        subtitle: 'Help The Poor, You Will Feel Happy',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Event-Raised-Poor',
        eimg: eimg5,
        eSimg: esing5,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '6',
        title: 'A hand for Children',
        subtitle: 'Help The Poor, You Will Feel Happy',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'A-hand-for-Children',
        eimg: eimg6,
        eSimg: esing6,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },

]
export default event;






